module.exports = __webpack_public_path__ + "img/comp-45.cd38a6ab.png";